import { lazy, Suspense } from "react";
import Navbar from "@/components/landing/Navbar";
import HeroManifesto from "@/components/landing/global/HeroManifesto";

// Below-the-fold bands lazy-load in parallel to keep the initial landing bundle small.
const TickerBand = lazy(() => import("@/components/landing/global/TickerBand"));
const ProblemBand = lazy(() => import("@/components/landing/global/ProblemBand"));
const SystemBand = lazy(() => import("@/components/landing/global/SystemBand"));
const PillarsBand = lazy(() => import("@/components/landing/global/PillarsBand"));
const ImpactBand = lazy(() => import("@/components/landing/global/ImpactBand"));
const ReachBand = lazy(() => import("@/components/landing/global/ReachBand"));
const ProofBand = lazy(() => import("@/components/landing/global/ProofBand"));
const FinalCtaBand = lazy(() => import("@/components/landing/global/FinalCtaBand"));
const ContactSection = lazy(() => import("@/components/landing/ContactSection"));
const FAQSection = lazy(() => import("@/components/landing/FAQSection"));
const Footer = lazy(() => import("@/components/landing/Footer"));
const FloatingCta = lazy(() => import("@/components/landing/FloatingCta"));

const SectionFallback = () => <div className="h-24" aria-hidden />;

const Index = () => (
  <div className="landing-v2 min-h-screen bg-background">
    <Navbar />
    <main>
      <HeroManifesto />
      <Suspense fallback={<SectionFallback />}>
        <TickerBand />
        <ProblemBand />
        <SystemBand />
        <PillarsBand />
        <ImpactBand />
        <ReachBand />
        <ProofBand />
        <FinalCtaBand />
        <ContactSection />
        <FAQSection />
      </Suspense>
    </main>
    <Suspense fallback={<SectionFallback />}>
      <Footer />
      <FloatingCta />
    </Suspense>
  </div>
);

export default Index;
